<template>
    <app-navbar :logo-url="urlGenerator(logo)"
                :user="user.loggedInUser"
                :selected-language="userLanguage"
                :language-data="languageList"
                notification-component="app-custom-notification-dropdown"
                :notificationData="notifications.data"
                :profile-data="profileData"
                :show-identifier="!!notifications.total_unread"
                :all-notification-url="urlGenerator('/notification/list')"
                :total-unread="notifications.total"
                @clicked="readNotification"
                @loadNotifications="loadNotification"/>
</template>

<script>
    import {mapActions} from "vuex";
    import AppFunction from "../../../core/helpers/app/AppFunction";
    import {axiosPost, urlGenerator} from "../../helpers/AxiosHelper";
    import {All_NOTIFICATION, APP_SETTINGS, LOGOUT, MY_PROFILE} from "../../config/ApiUrl";
    import { mapGetters } from 'vuex'
    import {UserMixin} from "../views/Auth/Mixins/UserMixin";

    export default {
        name : 'DashboardNavbar',
        mixins: [UserMixin],
        props: {
            logo: {
                type: String,
                default: AppFunction.getAppUrl('images/icon.png')
            }
        },
        data(){
            return{
                urlGenerator,
                profileData: [
                    {
                        optionName: 'My Profile',
                        optionIcon: 'user',
                        url: urlGenerator(MY_PROFILE)
                    },
                    {
                        optionName: 'Notifications',
                        optionIcon: 'bell',
                        url: urlGenerator(All_NOTIFICATION)
                    },
                    {
                        optionName: 'Settings',
                        optionIcon: 'settings',
                        url: urlGenerator(APP_SETTINGS)
                    },
                    {
                        optionName: 'Logout',
                        optionIcon: 'log-out',
                        url: urlGenerator(LOGOUT)
                    },
                ]
            }
        },
        created() {
            // this.$store.dispatch('getSettings');
            // this.$store.dispatch('getNotifications');
            // this.$store.dispatch('setSelectedLanguage');
            // // this.$store.dispatch('getUser');
            // this.$store.dispatch('getLanguages');
        },
        computed: {
            languageList() {
                return this.$store.state.language.languages
            },
            notifications() {
                return this.$store.getters.getFormattedNotifications
            },
            userLanguage() {
                return window.localStorage.getItem('app-language').toUpperCase()
            },
            ...mapGetters({ settings: 'settings' })
        },

        methods: {
            ...mapActions([
                'getNotifications'
            ]),
            readNotification(notification) {
                axiosPost(`admin/user/notifications/mark-as-read/${notification.id}`).then(({data}) => {
                    if (data.data.url) {
                        window.location = data.data.url;
                    }
                    this.getNotifications();
                });
            },
            loadNotification(){
                if(this.notifications?.next_page_url){
                    this.$store.dispatch('getNotifications', Number(this.notifications.current_page) + 1);
                }
            }
        }
    }
</script>
